'use client';

import { ReactNode, useEffect, useState } from 'react';
import { ProjectModel } from '@/lib/models/Project';
import { DesktopShell } from '@/components/DesktopShell';
import { MobileShell } from '@/components/MobileShell';
import { DeviceContext } from '@/components/DeviceContext';

interface Props {
  children: ReactNode;
  projects: ProjectModel[];
  initialIsMobile: boolean;
}

const MOBILE_QUERY = '(max-width: 767px)';
const TOUCH_DEVICE_QUERY = '(hover: none) and (pointer: coarse)';

export function SiteShell({ children, projects, initialIsMobile }: Props) {
  const [isMobile, setIsMobile] = useState(initialIsMobile);

  useEffect(() => {
    const mobileMq = window.matchMedia(MOBILE_QUERY);
    const touchDeviceMq = window.matchMedia(TOUCH_DEVICE_QUERY);
    const sync = () => {
      const nextIsMobile =
        initialIsMobile ||
        mobileMq.matches ||
        touchDeviceMq.matches ||
        navigator.maxTouchPoints > 0;

      setIsMobile((prev) => (prev === nextIsMobile ? prev : nextIsMobile));
    };

    sync();
    mobileMq.addEventListener('change', sync);
    touchDeviceMq.addEventListener('change', sync);
    return () => {
      mobileMq.removeEventListener('change', sync);
      touchDeviceMq.removeEventListener('change', sync);
    };
  }, [initialIsMobile]);

  return (
    <DeviceContext.Provider value={isMobile}>
      {isMobile ? (
        <MobileShell>{children}</MobileShell>
      ) : (
        <DesktopShell projects={projects}>{children}</DesktopShell>
      )}
    </DeviceContext.Provider>
  );
}
